/* eslint-disable quotes */
/* eslint-disable semi */
export const storeMutations = {
  loginMutation: 'loginMutation',
  setForgotPassword: 'setForgotPassword',
  setResetPassword: 'setResetPassword',
  setIsValidToken: 'setIsValidToken',
  SET_TIERS_LIST: 'SET_TIERS_LIST',
  SET_LICENCE_LIST: 'SET_LICENCE_LIST',
  SET_LICENCE_MANAGERS_LIST: 'SET_LICENCE_MANAGERS_LIST',
  licenseMutation: 'licenseMutation',
  setLicenseMutation: 'setLicenseMutation',
  licenseManagerMutation: 'licenseManagerMutation',
  roleListMutation: 'roleListMutation',
  setProfileMutation: 'setProfileMutation',
  tierMutation: 'tierMutation',
  setLicenseCount: 'setLicenseCount',
  setTierCount: 'setTierCount',
  tierList: 'tierList',
  vsmMutation: 'vsmMutation',
  setVsmMutation: 'setVsmMutation',
  designationMutation: 'designationMutation',
  setDesignationMutation: 'setDesignationMutation',
  domainMutation: 'domainMutation',
  setDomainMutation:'setDomainMutation',
  departmentMutation: 'departmentMutation',
  setDepartmentMutation:'setDepartmentMutation',
  // snackbar
  setSnackbarText: 'setSnackbarText',
  setCurrentUser:'setCurrentUser',

  vsmMetricList: 'vsmMetricList',
  setAddVsmMetric: 'setAddVsmMetric',
  setVsmsMutation: 'setVsmsMutation',
  setCustomerInfo: 'setCustomerInfo',
  setCustomerProfileByIdInfo:'setCustomerProfileByIdInfo',

  //analytics
  setDemoPaidUsers: 'setDemoPaidUsers',
  setAgencyOwnUsers: 'setAgencyOwnUsers',
  setUsersList: 'setUsersList',
  HtmlContentSaveMutation:'HtmlContentSaveMutation'
};
